import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"close\"><title>icn/close</title><path d=\"M9.9 8.485l2.828 2.829a1 1 0 0 1-1.414 1.414L8.485 9.899l-2.828 2.829a1 1 0 1 1-1.414-1.414L7.07 8.485 4.243 5.657a1 1 0 0 1 1.414-1.414L8.485 7.07l2.829-2.828a1 1 0 0 1 1.414 1.414L9.899 8.485z\" id=\"close_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol